import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const noteTemplateTypesAdapter = getAdapter({ idFieldName: 'value' });

const noteTemplateTypesSlice = createSlice({
  name: 'noteTemplateTypes',
  initialState: noteTemplateTypesAdapter.getInitialState(),
  reducers: {
    setNoteTemplateTypes: (state, { payload: { noteTemplateTypes } }) => {
      noteTemplateTypesAdapter.setAll(state, noteTemplateTypes);
    },
  },
});

const selectors = noteTemplateTypesAdapter.getSelectors(({ noteTemplateTypes }) => noteTemplateTypes);

export const getNoteTemplateTypes = (state) => selectors.selectAll(state);

export const {
  setNoteTemplateTypes,
} = noteTemplateTypesSlice.actions;

export default noteTemplateTypesSlice.reducer;
